import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Modal, Row } from "react-bootstrap";

import { useDarknetIdentity } from "../../contexts/IdentityContext";
import ApiService from "../../services/ApiService";
import StorageService from "../../services/StorageService";
import { getGameAssetsUrl } from "../../utilities/Helpers";
import CustomTooltip from "../common/CustomTooltip";

const CasualModal = () => {
  const navigate = useNavigate();
  const { authenticated } = useDarknetIdentity();
  const [show, setShow] = useState(false);

  const [selectedGame, setSelectedGame] = useState<Game>();

  useEffect(() => {
    ApiService.get('/games/library').then((response) => {
      if (!response) throw new Error("No response");
      if (response.success) {
        setSelectedGame(response.data.filter((game: Game) => game.shortName === 'pong')[0]);
      }
    }).catch((error: any) => {
      console.error(error);
    });
  }, []);

  async function handleCreateGame() {
    if (!authenticated) return;
    try {
      let response = await ApiService.post('/creategame');
      if (!response) throw new Error('No response');
      if (response.success) {
        // If the token is not null, set it in local storage.
        if (response.data.token) StorageService.set('authToken', response.data.token);
        navigate(`/${selectedGame?.shortName}/${response.data.id}`);
      } else {
        console.error(response.message);
        window.alert(response.message);
      }
    } catch (error: any) {
      console.error(error);
      window.alert(error.message);
    }
  }

  const FeaturedGames = () => {
    return (<>
      <h6>Featured Games</h6>
      <Row>
        <Col xs={2}>
          <CustomTooltip title="Dark Pong" id="dark-pong-wagered" placement={"bottom"}>
            <button className="dg-btn dg-btn-mid-dark py-2">
              <img src={`${getGameAssetsUrl(1)}/icon.png`} alt="Dark Pong" height={32} />
            </button>
          </CustomTooltip>
        </Col>
      </Row>
    </>);
  }

  return (
    <>
      <button
        className="dg-btn dg-btn-primary text-light px-3 pt-1 pb-2 fs-7"
        onClick={() => setShow(true)}
      >
        Create Casual Game
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="dg-modal"
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>
            Create Casual Game
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="g-3 mb-3">
            <FeaturedGames />
          </Row>
        </Modal.Body>
        <Modal.Footer className="">
          <Col>
            <button
              className="dg-btn dg-btn-secondary dg-btn-block"
              onClick={() => setShow(false)}
            >
              Close
            </button>
          </Col>
          <Col>
            <button
              className="dg-btn dg-btn-primary dg-btn-block text-light"
              onClick={handleCreateGame}
            >
              Create Game
            </button>
          </Col>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CasualModal;
